import { connect } from 'react-redux';
import { addToHistoryRoutine } from 'redux-state/ducks/history';
import HistoryPersistence from './history-persistence.component';

const mapDispatchToProps = {
  addToHistoryAction: addToHistoryRoutine.request,
};

export default connect(null, mapDispatchToProps)(HistoryPersistence);
